import React from 'react';
import { useLocation, Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function DocumentsGate({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  const pending = Boolean(user?.documentsAAccepter?.length);
  const onAcceptationPage = location.pathname === '/acceptation-documents';

  if (loading) {
    return (
      <div className="flex justify-center items-center min-h-screen">
        <div className="text-lg text-gray-600">Chargement...</div>
      </div>
    );
  }

  if (pending && !onAcceptationPage) {
    return (
      <Navigate
        to="/acceptation-documents"
        replace
        state={{ from: `${location.pathname}${location.search}` }}
      />
    );
  }

  if (!pending && onAcceptationPage && user) {
    const roles = user.roles || [user.role];
    const isAdmin = roles.includes('admin') || roles.includes('super_admin');
    return <Navigate to={isAdmin ? '/admin/dashboard' : '/dashboard'} replace />;
  }

  return children;
}
